<template>
  <footer class="footer px-4">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="12">
        <div class="copyright text-center text-lg-left text-muted justify-content-lg-start">
          © {{year}} <span class="font-weight-bold ml-1 companyName">Bond Consulting</span>
          <span class="float-right">Version {{applicationVersion}}</span>
        </div>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      applicationVersion: ""
    };
  },
  mounted(){
    this.getApplicationVersion().then((res)=>{
        if(res && res.data){
          this.applicationVersion = res.data
        }
    });
  },
  methods: {
        ...mapActions("admin", ["getApplicationVersion"]),
  }
};
</script>
<style>

.companyName{
  color: #921210;
}

footer {
   position:fixed; 
  clear: both;
  left: 0;
  background-color: rgb(255, 255, 255) !important;
  bottom: 0 !important ;
  width: 100%;
  padding: 12px !important;
  font-size: 14px !important;
  /* z-index: -2; */
}

</style>
